<template>
  <div class="sale-show-billet">
    <button class="btn-close" @click="$emit('close')">
      <i class="icon-x"></i>
    </button>
    <p><strong>Valor:</strong> {{ amount }}</p>
    <p><strong>Data de vencimento:</strong> {{ dueAt }}</p>
    <p><strong>Código:</strong> {{ item.billet.line }}</p>
    <div class="d-flex align-items-center justify-content-between mx-n3 pt-6">
      <a
        class="btn btn-outline-primary mx-3 px-6"
        :href="item.billet.url"
        target="_blank"
        >Abrir link</a
      >
      <a
        class="btn btn-primary mx-3 px-6"
        :href="item.billet.pdf"
        target="_blank"
        >Abrir pdf</a
      >
    </div>
    <template v-if="$permissions.hasPermission('emitir-boletos')">
      <hr />
      <button class="btn btn-block btn-primary" @click="reBilletDialog = true">
        <loading :show="loading">Emitir novo boleto</loading>
      </button>
    </template>

    <confirmation
      v-model="reBilletDialog"
      @confirm="reBillet"
      text="Tem certeza que deseja emitir novo boleto?"
    />
  </div>
</template>

<script>
import { formatMoney, toHumanDate } from "../../functions/helpers";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      reBilletDialog: false
    };
  },
  computed: {
    amount() {
      return formatMoney(this.item.billet.amount);
    },
    dueAt() {
      return toHumanDate(this.item.billet.due_at);
    }
  },
  methods: {
    reBillet() {
      this.loading = true;
      window.axios
        .post(`/payment/re-billet/${this.item.id}`)
        .then(response => {
          this.item.billet = response.data;
          this.$message.success("Novo boleto emitido com sucesso");
        })
        .catch(() => {
          this.$message.error("Erro ao emitir novo boleto");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-show-billet {
  position: relative;

  .btn-close {
    font-size: 20px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    background: transparent;
    border: none;
  }
}
</style>
